import { gapi } from 'gapi-script'
import { useEffect, useState } from 'react'

import { useMobile } from './useMobile'
import { useRecoilState } from 'recoil'
import { userState } from '../../states/userState'
import {
  API_KEY,
  CLIENT_ID,
  refreshTime,
  SCOPES,
} from '../../constants/googleAuth'
import { User } from '../../types'
import { formatTime } from '../../utils/functions/formatting'
import { accessTokenState } from '../../states/accessTokenState'
import { useLoginOAuth2 } from '../useLoginOAuth2'
import { useLogoutOAuth2 } from '../useLogoutOauth2'

export const useAccressToken = () => {
  const [token, setToken] = useState('')
  const [user, setUser] = useRecoilState<User>(userState)
  const [autState, setAuthState] = useState(false)
  const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
  const { isMobile } = useMobile()
  const { logout } = useLogoutOAuth2()
  console.log('isMobile', isMobile)

  useEffect(() => {
    console.log('isMobile', isMobile)
    if (isMobile !== null && isMobile) {
      console.log('モバイル環境のため、トークンの監視・更新を無効化')
      return
    }

    const initClient = async () => {
      try {
        console.log('DEBUT_TOKEN_initClientが呼ばれました')
        const result = await gapi.client.init({
          apiKey: API_KEY,
          clientId: CLIENT_ID,
          scope: SCOPES.join(' '),
          discoveryDocs: [
            'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
          ],
          prompt: 'consent',
          cookie_policy: 'single_host_origin',
        })
        // console.log("DEBUT_TOKEN_initClientが完了しました", result);
      } catch (error) {
        console.log('DEBUT_TOKEN_エラーが発生しました', error)
      }
      // console.log("DEBUT_TOKEN_インスタンスを取得します");
      const authInstance = gapi.auth2.getAuthInstance()
      // console.log("DEBUT_TOKEN_authInstance", authInstance);
      authInstance.isSignedIn.listen((signedIn: boolean) => {
        // console.log("DEBUT_TOKEN_listen", signedIn);
        if (signedIn) {
          handleUserSignIn()
        } else {
          // console.log("ok1");
          handleUserSignOut()
        }
      })

      const signedIn = authInstance.isSignedIn.get()
      if (signedIn) {
        await handleUserSignIn() // サインイン時の処理
      } else {
        console.log(user.isAuth)
        if (isMobile !== null && !isMobile) {
          handleUserSignOut()
        }
      }
    }

    const handleUserSignIn = async () => {
      const authInstance = gapi.auth2.getAuthInstance()
      const user = authInstance.currentUser.get()
      const newAuthResponse = await user.reloadAuthResponse() // アクセストークンをリフレッシュ
      const accessToken = newAuthResponse.access_token
      const authResponse = user.getAuthResponse(true)
      console.log('アクセストークン確認', accessToken)
      const currentTime = Date.now()
      const expiresAt = authResponse.expires_at
      const expiresIn = expiresAt - currentTime
      console.log(
        `ロード：アクセストークンの残り有効時間: ${
          expiresIn / 1000 / 60
        }分:${formatTime(new Date())}`
      )
      setToken(accessToken)
      setAccessToken(accessToken)
    }

    const handleUserSignOut = () => {
      const authInstance = gapi.auth2.getAuthInstance()
      authInstance.signOut().then(async () => {
        await logout()
      })
    }
    if (isMobile !== null && !isMobile) {
      gapi.load('client:auth2', () => {
        initClient()
      })
    }
  }, [isMobile])

  const refreshAccessToken = async () => {
    console.log('isMobile', isMobile)
    if (isMobile !== null && isMobile) {
      console.log('モバイル環境のため、トークンの監視・更新を無効化')
      return
    }
    if (isMobile !== null && !isMobile) {
      try {
        const authInstance = gapi.auth2.getAuthInstance()
        const currentUser = authInstance.currentUser.get()
        console.log(`現在のユーザー:${currentUser.isSignedIn()}`)
        // ユーザーがサインインしているか確認
        if (authInstance.isSignedIn.get()) {
          const authResponse = currentUser.getAuthResponse(true)
          const expiresAt = authResponse.expires_at
          const currentTime = Date.now()
          const expiresIn = expiresAt - currentTime
          const minutesLeft = expiresIn / 1000 / 60

          console.log(
            `定期確認:アクセストークンの残り有効時間: ${minutesLeft.toFixed(
              2
            )}分:トークン${token}`
          )
          // 残り時間が5分以下の場合にトークンを更新
          if (minutesLeft <= 10) {
            console.log('アクセストークンの更新の分岐に入りました！')
            const newAuthResponse = await currentUser.reloadAuthResponse()
            console.log(
              `更新しました！:アクセストークンの残り有効時間: ${minutesLeft.toFixed(
                2
              )}分:トークン${newAuthResponse.access_token}`
            )
            setToken(newAuthResponse.access_token)
            setAccessToken(newAuthResponse.access_token)
          }
        } else {
          const authInstance = gapi.auth2.getAuthInstance()
          authInstance.signOut().then(async () => {
            await logout()
          })
        }
      } catch (error) {
        console.error('Error refreshing access token:', error)
        const authInstance = gapi.auth2.getAuthInstance()
        authInstance.signOut().then(async () => {
          await logout()
        })
      }
    }
  }

  useEffect(() => {
    let refreshInterval: any
    if (isMobile !== null && isMobile) {
      console.log('モバイル環境のため、トークンの監視・更新を無効化')
      return
    }
    if (isMobile !== null && !isMobile) {
      console.log('トークンの監視・更新を開始します')

      refreshInterval = setInterval(() => {
        refreshAccessToken()
      }, refreshTime)
    }
    return () => {
      if (refreshInterval) clearInterval(refreshInterval)
    }
  }, [isMobile])

  return { token, setToken }
}
